import React from "react";
import { CONTACT } from "../constants";

export default function WhatsAppFloat() {
  return (
    <a
      href={`${CONTACT.whatsappUrl}?text=${encodeURIComponent(
        "Hola Ruizcare, me gustaría más información sobre vuestros servicios."
      )}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      data-testid="whatsapp-float"
      className="wa-pulse fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg hover:scale-105 transition-transform"
    >
      <svg viewBox="0 0 32 32" className="h-7 w-7" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.04 1.397-1.04 2.4 0 .53.13 1.06.272 1.504.516 1.62 1.05 2.99 2.31 4.205 1.42 1.39 3.01 2.405 4.876 3.105.31.115.6.187.93.215 1.13.043 2.46-1.275 2.46-2.343 0-.343-.057-.358-.43-.6-.215-.14-.78-.428-1.13-.6-.55-.265-1.31-.518-1.46-.515zm-2.84 5.71c-1.55 0-3.04-.43-4.34-1.245l-3.04.8.81-2.97a8.78 8.78 0 0 1-1.36-4.69c0-4.86 3.96-8.82 8.83-8.82s8.82 3.96 8.82 8.82-3.95 8.82-8.82 8.82l.1-.07zm0-19.42C10.04 3.495 4 9.535 4 16.83c0 2.4.62 4.7 1.79 6.78L4.07 30l6.6-1.73c1.99 1.07 4.22 1.66 6.5 1.66 7.31 0 13.34-6.06 13.34-13.36 0-7.3-6.03-13.07-13.34-13.07z"/>
      </svg>
    </a>
  );
}
